import * as Yup from "yup";

const formValidation = Yup.object().shape({
  number: Yup.number().positive("Must be positive number").required("required"),
  cycleStart: Yup.date().required("required"),
  cycleEnd: Yup.date().required("required"),
  gracePeriod: Yup.number()
    .min(0, "Must be positive number")
    .required("required"),
});

export default formValidation;
